import api from "../api";

const sendVerification = async (phone) => {
  const requestData = {
    "phone": phone,
  }
  try {

    const response = await api.post(process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT + "/app/auth/forget-password-sms", requestData);
    return response.data;
  }
  catch (error) {
    console.error('There was a problem with the axios operation:', error);
    throw error;
  }

}

export default sendVerification;
